 // Updated the SIP function to use async/await and added error handling - 15/10/24 - Dev Srini

const handleStartCall = async (number, dispatch) => {
    const mobileNumber = `91${number}`

    dispatch({
        type: 'SET_CUSTOMER_PHONE_NUMBER',
        payload: number
    })

    dispatch({
        type: 'SET_START_CALL',
        payload: true
    })

    dispatch({
        type: 'SET_DISPLAY_NUMBER',
        payload: number
    })

    dispatch({
        type: 'SET_OUT_BOUND_CALLING',
        payload: true
    })

    dispatch({
        type: 'SET_ERROR',
        payload: 'Calling'
    })

    dispatch({
        type: 'SET_CALL_ICON_TOGGLE',
        payload: true
    })

    window.txtPhoneNumber.value = mobileNumber

    try {
        await window.sipCall()
        console.log("Call initiated successfully to:", mobileNumber)

        await window.sipPublish('closed', 'Busy', 'I am with client call')
        console.log("SIP status published: 'Closed' - 'Busy' - 'I am with client call'")

        dispatch({
            type: 'SET_AGENT_PUBLISH_STATS',
            payload: 'closed'
        })
    } 
    catch (error) {
        console.error('Error during outbound call:', error)
    }
}

export default handleStartCall